<template>
    <button class="lang-btn">
        <div type="button" id="dropdownMenuButton" data-toggle="dropdown" class="lang-btn-icon-text">
            <span class="language-code">{{ getSelectedLanguage.code.toUpperCase() }}</span>
            <!-- <div class="language-icon-placeholder d-inline-block">
                <img v-bind:src="getSelectedLanguage.url" class="rounded"/>
            </div> -->
            <!-- <div class="language-icon-placeholder">
                <img v-bind:src="getSelectedLanguage.url" class="rounded"/>
            </div> -->
        </div>
        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <a v-for="language in getLanguages" v-bind:key="language.id" class="dropdown-item btn" v-on:click="changeLocale(language)">
                <!-- <div class="language-icon-placeholder d-inline-block">
                    <img v-bind:src="language.url" v-bind:alt="language.alt" class="rounded"/>
                </div> -->
                <span class="ml-2 language-name">{{ language.name }}</span>
            </a>
        </div>
    </button>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'

    export default {
        data() {
            return {
            }
        },
        computed: {
            ...mapGetters(["getLanguages", "getSelectedLanguage"])
        },
        methods: {
            ...mapActions(["changeLanguage", "loadContents"]),
            changeLocale(language) {

                if (language.code != this.getSelectedLanguage.code) {
                    this.changeLanguage(language);
                    this.loadContents();
                    this.$router.push({
                        params: { lang: language.code },
                        query: this.$route.query
                    });
                }
            }
        }
    }
</script>

<style scoped>
.lang-btn{
    border: none;
    background-color: transparent;
}
.lang-btn span{
    /* font-size: 24px; */
    font-size: 1.3rem;
    line-height: 1.4rem;
    /* line-height: 30px; */
    font-weight: 400;
    color: var(--main-color);
    /* letter-spacing: -1px; */
}
.language-icon-placeholder {
    width: 30px;
    height: 24px;
    /* padding: 2px; */
    display: flex;               
    justify-content: center;    
    align-items: center; 
}
.language-icon-placeholder img {
    object-fit: fill;
    width: 100%;
    height: 100%;
    /* margin-bottom: 5%; */
}
.language-name {
    color: var(--main-color);
}
.dropleft {
    border: 1px solid var(--main-color) !important;
    border-radius: 5px;
}
.dropleft:hover {
    background-color: #374e96 !important;
}
.language-code {
    line-height: 1px;
    font-size: 13px;
}
.lang-btn-icon-text{
    display: flex;
    /* align-items: end; */
    gap: 2px;
}
@media only screen and (max-width: 992px){
    .lang-btn{
        padding: 0%;
    }

    img{
        vertical-align: text-top;
    }
}
</style>
